export const iconTypes = [
    'Arrow',
    'ArrowCircle',
    'Bed',
    'Bicycle',
    'Bin',
    'CabinBag',
    'Calendar',
    'CalendarCheck',
    'Car',
    'Card',
    'Cog',
    'Chat',
    'Check',
    'CheckedBag',
    'Chevron',
    'Cookie',
    'Copy',
    'Cross',
    'Dollar',
    'Door',
    'Download',
    'Envelope',
    'Exclamation',
    'External',
    'Ferry',
    'Gift',
    'Golf',
    'HappyCircle',
    'InfoCircle',
    'Meal',
    'MiniBus',
    'Minus',
    'MinusCircle',
    'Mobile',
    'MotorBike',
    'NoBag',
    'Offer',
    'Paw',
    'Plane',
    'Plus',
    'PlusCircle',
    'Protection',
    'Refresh',
    'Seat',
    'Sembo',
    'SemboSun',
    'ShieldCheck',
    'SmallBag',
    'Star',
    'HalfStar',
    'Support',
    'ThumbDown',
    'ThumbUp',
    'Ticket',
    'Timer',
    'Train',
    'User',
    'Van',
    'Wand',
] as const;

export const iconColors = [
    'black',
    'white',
    'grey',
    'darkGrey',
    'green',
    'primary',
    'error',
    'jungle',
    'violet',
] as const;

export const iconBackgrounds = ['white', 'transparent'];
export const iconSizes = ['auto', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];

export type Size = (typeof iconSizes)[number];
export type Type = (typeof iconTypes)[number];
export type Color = (typeof iconColors)[number];
export type Background = (typeof iconBackgrounds)[number];
